// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__3xhZN","label":"input_label__3zBxt"};